import React, { useState } from "react"
import PropTypes from "prop-types"
// Material Ui
import { Box, Button, Typography } from "@material-ui/core"
import { words } from "../../i18n/lstrings"
import useSmartFormat from "../../i18n/useSmartFormat"
import TypographyHtml from "../typography/TypographyHtml"

const propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  TextProps: PropTypes.object
}

const defaultProps = {
  TextProps: {}
}

const TextArea = (props) => {
  const { title, data, TextProps } = props
  const format = useSmartFormat()
  const {
    disabled,
    component,
    maxLength,
    maxWidth,
    showTitle,
    renderText,
    renderTitle: textPropsRenderTitle,
    id,
    ...textProps
  } = TextProps
  const expandable = maxLength && data && data.length > maxLength
  const [expanded, setExpanded] = useState(!expandable)

  if (disabled) {
    return null
  }
  const renderTitle = () => {
    if (textPropsRenderTitle) {
      return textPropsRenderTitle(
        { className: "bookmark-widget-text-title" },
        title
      )
    }
    return (
      <Typography
        variant="body2"
        style={{ fontWeight: "bold" }}
        color="textPrimary"
        gutterBottom
      >
        {title}
      </Typography>
    )
  }

  return (
    <Box
      component={component}
      padding={component === "span" ? 0 : 2}
      maxWidth={maxWidth}
      style={component === "span" ? { backgroundColor: "transparent" } : {}}
      elevation={0} // GAM style
      id={id ?? ""}
    >
      {showTitle && renderTitle()}
      {renderText &&
        renderText(
          {
            ...textProps,
            noWrap: !expanded,
            variant: "body2",
            gutterBottom: true
          },
          data
        )}
      {!renderText && (
        <TypographyHtml
          {...textProps}
          noWrap={!expanded}
          variant="body2"
          gutterBottom
        >
          {data}
        </TypographyHtml>
      )}
      {expandable && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded
            ? `- ${format(words.collapse)}`
            : `+ ${format(words.expand)}`}
        </Button>
      )}
    </Box>
  )
}

TextArea.propTypes = propTypes
TextArea.defaultProps = defaultProps

export default TextArea
